export default "__VITE_ASSET__C6jUOzot__"